import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import loadPerformanceWidgetPerfs from "@tecumseh/Handlers/PerformancePerfsData";
import {
    getWidgetFreqInfo,
    PerformanceWidgetFreqs,
    WidgetInfoFreqParameter,
} from "@tecumseh/Services/PerformanceWidgetService";
import { CustomApiHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

// Define the custom API handler type
type WidgetInfoHandlerType = CustomApiHandler<WidgetInfoFreqParameter, PerformanceWidgetFreqs>;

// Custom API handlers
export const DispatchBeginWidgetFreqs: WidgetInfoHandlerType = props => {
    props.dispatch({
        type: "Custom/WidgetInfo/BeginLoadWidgetFreqs",
    });
};

export const RequestWidgetFreqs: WidgetInfoHandlerType = async props => {
    props.apiResult = await getWidgetFreqInfo(props.parameter);

    if ((props.apiResult as any).error) {
        // TODO: Set Error in Reducer
        return false;
    }
};

export const WidgetFreqsCompleted: WidgetInfoHandlerType = props => {
    props.dispatch({
        type: "Custom/WidgetInfo/CompleteLoadWidgetFreqs",
        widgetFreqs: props.apiResult,
    });
};

export const LoadWidgetPerfs: WidgetInfoHandlerType = props => {
    const { model, type, fluide, mid, applicationId } = props.parameter;
    const productFreq = props.apiResult && props.apiResult.length > 0 ? props.apiResult[0] : undefined;
    if (productFreq) {
        props.dispatch(
            loadPerformanceWidgetPerfs({
                model,
                fluide,
                frequency: productFreq,
                mid,
                application: applicationId,
                type,
            }),
        );
    }
};

export const widgetFreqChain = [DispatchBeginWidgetFreqs, RequestWidgetFreqs, WidgetFreqsCompleted, LoadWidgetPerfs];

const loadPerformanceWidgetFrequencies = createHandlerChainRunner(widgetFreqChain, "LoadPerformanceWidgetFrequencies");

export default loadPerformanceWidgetFrequencies;
